import { Lock } from "lucide-react";

export const PrivateNote = ({ testId = "contact-private-note", className = "" }) => (
  <p className={`flex items-start gap-2 rounded-lg border border-emerald-400/20 bg-emerald-400/[0.06] px-3 py-2 text-xs text-emerald-100/90 ${className}`} data-testid={testId}>
    <Lock size={13} className="shrink-0 mt-0.5 text-emerald-300" />
    <span>Only you can see your saved contacts, the professions you give them and your notes. Friends, people viewing your profile and the contacts themselves never see them.</span>
  </p>
);
